import i18n from '@/utils/i18n';
import React from 'react';
import { ActivityIndicator, StyleProp, View, ViewStyle } from 'react-native';
import { createStyles, useTheme } from '@/contexts/theme-context';
import { LIST_ITEM_HEIGHT } from '@/experiences/sales-portal/components/address-search-input/constants';
import { Typography } from '@usepepper/ui/atoms/typography';

interface AddressSearchLoadingStateProps {
  style?: StyleProp<ViewStyle>;
}

const AddressSearchLoadingState: React.FC<AddressSearchLoadingStateProps> = ({
  style,
}) => {
  const [styles] = useStyles();
  const theme = useTheme();

  return (
    <View style={[styles.loadingContainer, style]}>
      <ActivityIndicator color={theme.sk.color.text.secondary} size="small" />
      <Typography variant="paragraph-sm">
        {i18n.t('sales_portal.edit_account.address_search.searching')}
      </Typography>
    </View>
  );
};

export default AddressSearchLoadingState;

const useStyles = createStyles((theme) => ({
  loadingContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    height: LIST_ITEM_HEIGHT,
    justifyContent: 'center',
    padding: theme.sk.spacing.spaceSMedium,
  },
}));
